import { render, staticRenderFns } from "./CameraTypeIcon.vue?vue&type=template&id=4f70988d&scoped=true"
import script from "./CameraTypeIcon.vue?vue&type=script&lang=ts"
export * from "./CameraTypeIcon.vue?vue&type=script&lang=ts"
import style0 from "./CameraTypeIcon.vue?vue&type=style&index=0&id=4f70988d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70988d",
  null
  
)

export default component.exports